import { useCallback, useEffect } from 'react';
// ** Store Imports
import { useDispatch, useSelector } from 'react-redux';

import { handleSkin } from '../../store/layout';
import { useThemeContext } from '../context/ThemeColors';

export const useSkin = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const layoutStore = useSelector((state) => state.layout);
  const { themeConfig: { images = {} } } = useThemeContext();

  const setSkin = useCallback((type) => {
    dispatch(handleSkin(type));
  }, [dispatch]);

  useEffect(() => {
    // ** Get Body Tag
    const element = window.document.body;

    // ** Define classnames for skins
    const classNames = {
      dark: 'dark-layout',
      bordered: 'bordered-layout',
      'semi-dark': 'semi-dark-layout'
    };

    // ** Remove all classes from Body on mount
    element.classList.remove(...element.classList);

    // ** If skin is not light add skin class
    if (layoutStore.skin !== 'light') {
      element.classList.add(classNames[layoutStore.skin]);
    }
  }, [layoutStore.skin]);

  const illustration = layoutStore.skin === 'dark' ? 'login-v2-dark.svg' : 'login-v2.svg';
  // eslint-disable-next-line import/no-dynamic-require
  const source = images.wellcomeImage || require(`../../assets/images/pages/${illustration}`).default;
  return { skin: layoutStore.skin, setSkin, loginImage: source };
};
